module.exports = __webpack_public_path__ + "img/product-program-ykp-icon1.67517c8e.png";